/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_ad__magazine__button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Reisen`
};

const en_ad__magazine__button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Travel`
};

const es_ad__magazine__button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Viajar`
};

const fr_ad__magazine__button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Voyager`
};

const it_ad__magazine__button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Viaggi`
};

const nl_ad__magazine__button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Reizen`
};

const pt_ad__magazine__button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Viagens`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__button_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ad__magazine__button_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ad__magazine__button_label", locale)
	if (locale === "de") return de_ad__magazine__button_label(inputs)
	if (locale === "en") return en_ad__magazine__button_label(inputs)
	if (locale === "es") return es_ad__magazine__button_label(inputs)
	if (locale === "fr") return fr_ad__magazine__button_label(inputs)
	if (locale === "it") return it_ad__magazine__button_label(inputs)
	if (locale === "nl") return nl_ad__magazine__button_label(inputs)
	return pt_ad__magazine__button_label(inputs)
};